<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / APP訂購餐點分析</b-col>
      <b-col>
        <div class="text-right">
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">品牌：</label>
                  <div class="col-md-3">
                      <select
                        id="queryBrandsCode"
                        name="queryBrandsCode"
                        class="form-control col-md-9"
                        v-model="queryBrandsCode"
                        @change="getProductAll();getAllCombos();getpost()"
                      >
                      <option
                        v-for="x in selectListBrands"
                        v-bind:value="x.Code"
                        :key="x.Code"
                      >{{x.Text}}</option>
                      </select>
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">區間：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">單品/套餐：</label>
                  <b-form-radio-group class="col-md-2 mt-2" v-model="producttype" @change="producttypechange()">
                    <b-form-radio v-bind:value="1" :key="1">單品</b-form-radio>
                    <b-form-radio v-bind:value="4" :key="4">套餐</b-form-radio>
                  </b-form-radio-group>
                  <!-- <label class="control-label col-md-2 mt-2 text-right" v-if="producttype == 1">單品含套餐內品項：</label>
                  <b-form-radio-group class="col-md-2 mt-2" v-model="addincombo" v-if="producttype == 1">
                    <b-form-radio v-bind:value="1" :key="1">是</b-form-radio>
                    <b-form-radio v-bind:value="2" :key="2">否</b-form-radio>
                  </b-form-radio-group> -->
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right" v-if="producttype == 1">商品分類：</label>
                  <div class="col-md-3" v-if="producttype == 1">
                    <select class="form-control" id="productgroup"
                      name="productgroup" @change="productgroupchage()"
                      v-model="productgroup">
                      <option v-bind:value="''" :key="''">全部</option>
                      <option v-for='x in productgrouplist' v-bind:value='x.Attribute' :key='x.Attribute'>{{x.Attribute}}</option>
                    </select>
                  </div>
                  <label class="control-label col-md-2 mt-2 text-right">商品：</label>
                  <div class="col-md-3">
                    <multiselect v-model="productcode" :options="productlist" :custom-label="nameWithLang" :multiple="false" v-if="producttype == 1" group-values="Detail" group-label="Attribute" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" :show-labels="false">
                      <span slot="noResult">查無資料</span>
                    </multiselect>
                    <multiselect v-model="combosid" :options="combos" :custom-label="nameWithLang" :multiple="false" v-if="producttype == 4" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" :show-labels="false">
                      <span slot="noResult">查無資料</span>
                    </multiselect>
                    <!-- <select class="form-control col-md-9" id="productcode" name="productcode" v-model="productcode">
                      <option v-bind:value="''" :key="''">全部</option>
                      <option v-for="x in productlist" v-bind:value="x.Code" :key="x.Code">{{x.Name}}</option>
                    </select> -->
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">會員分類：</label>
                  <div class="col-md-3">
                    <select class="form-control" id="membergradeid" name="membergradeid" v-model="membergradeid" @change="membergradechange()">
                      <option v-bind:value="0" :key="0">全部</option>
                      <option v-bind:value="10" :key="10">基本會員</option>
                      <option v-bind:value="20" :key="20">正式會員</option>
                    </select>
                  </div>
                  <label class="control-label col-md-2 mt-2 text-right">會員年齡：</label>
                  <div class="col-md-3">
                    <select class="form-control" id="age" name="age" v-model="age" :disabled="membergradeid == 10 ? '' : disabled">
                      <option v-bind:value="0" :key="0">全部</option>
                      <option v-bind:value="1" :key="1">20以下</option>
                      <option v-bind:value="2" :key="2">20~29</option>
                      <option v-bind:value="3" :key="3">30~39</option>
                      <option v-bind:value="4" :key="4">40~49</option>
                      <option v-bind:value="5" :key="5">50~59</option>
                      <option v-bind:value="6" :key="6">60~69</option>
                      <option v-bind:value="7" :key="7">70~79</option>
                      <option v-bind:value="8" :key="8">80歲以上</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">會員性別：</label>
                  <div class="col-md-3">
                    <select class="form-control" id="membergender" name="membergender" v-model="membergender" :disabled="membergradeid == 10 ? '' : disabled">
                      <option v-bind:value="''" :key="''">全部</option>
                      <option v-bind:value="'male'" :key="'male'">男</option>
                      <option v-bind:value="'female'" :key="'female'">女</option>
                      <option v-bind:value="'private'" :key="'private'">不公開</option>
                    </select>
                  </div>
                  <label class="control-label col-md-2 mt-2 text-right">地區：</label>
                  <div class="col-md-3">
                    <select class="form-control" id="city" name="city" v-model="city">
                      <option v-bind:value="''" :key="''">全部</option>
                      <option v-for="x in citylist" v-bind:value="x.City" :key="x.City">{{x.City}}</option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                      <button type="button" class="btn btn-warning text-white" @click="getinformationapporder(1)">查詢</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      <b-card class="bg-default-card">
        <ve-histogram :data="chartData" :colors="colors" :settings="chartSettings"></ve-histogram>
      </b-card>
    </div>
  </div>
</template>
<script>
import IEcharts from 'vue-echarts-v3/src/full.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import Histogram from 'v-charts/lib/histogram.common'
import Vue from 'vue'
import axios from 'axios'
import miniToastr from 'mini-toastr'
import {API_URL} from '../../../store/root.js'
import Multiselect from 'vue-multiselect'

Vue.component(Histogram.name, Histogram)

export default {
  name: 'echarts',
  components: {
    IEcharts, Histogram, Multiselect
  },
  data () {
    this.colors = ['#02A7ED', '#EC7E8B', '#AFAFAF']
    this.chartSettings = {
      yAxisName: ['數量'],
      max: [10]
    }
    return {
      productgrouplist: [], // 票券類別下拉
      citylist: [], // 地區類別下拉
      combos: [], // POS類別清單
      productlist: [], // 票券下拉,
      selectListBrands: [], // 品牌下拉選單

      queryBrandsCode: 'MWD',
      sdate: '',
      edate: '',
      producttype: 1, // 單品/套餐
      //addincombo: 1, // 單品含套餐內品項
      productgroup: '', // 商品分類
      productcode: '', // 商品
      combosid: '', // 套餐
      membergradeid: 0, // 會員類型
      age: 0, // 年齡
      membergender: '', // 性別
      city: '', // 地區
      search: {
        sdate: '',
        edate: '',
        producttype: 1, // 單品/套餐
        //addincombo: 1, // 單品含套餐內品項
        productgroup: '', // 商品分類
        productcode: '', // 商品
        combosid: '', // 套餐
        age: 0, // 年齡
        membergradeid: 0, // 會員類型
        membergender: '', // 性別
        city: '' // 地區
      },
      chartData: {
        columns: ['年紀', '男', '女', '不公開'],
        yAxisName: ['數量'],
        rows: [
          { '年紀': '20以下', '男': 0, '女': 0, '不公開': 0 },
          { '年紀': '20~29', '男': 0, '女': 0, '不公開': 0 },
          { '年紀': '30~39', '男': 0, '女': 0, '不公開': 0 },
          { '年紀': '40~49', '男': 0, '女': 0, '不公開': 0 },
          { '年紀': '50~59', '男': 0, '女': 0, '不公開': 0 },
          { '年紀': '60~69', '男': 0, '女': 0, '不公開': 0 },
          { '年紀': '70~79', '男': 0, '女': 0, '不公開': 0 },
          { '年紀': '80以上', '男': 0, '女': 0, '不公開': 0 }
        ]
      }
      // bar chart
    }
  },
  created () {
    this.setdate()
    this.getpost()
    this.getProductAll()
    this.getinformationapporder(1)
    this.getAllCombos()
    this.FunctionPermission = getFunctionPermission('F22') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
    this.querySelectListBrands()
  },
  methods: {
    setdate () {
      var date = new Date()
      date.setMonth(date.getMonth() + 1)
      date.setDate(0)
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.sdate = year + '-' + mon + '-01'
      this.edate = year + '-' + mon + '-' + day
    },
    getinformationapporder (currentPage) {
      if (this.sdate === '' || this.edate === '' || this.sdate > this.edate) {
        miniToastr.error('請選擇正確的效期區間')
        return
      }
      var productcode = ''
      if (this.producttype==1) {
        productcode = this.productcode.Code
      } else {
        productcode =this.combosid.Code
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/apporder/v1', {
        sdate: this.sdate,
        edate: this.edate,
        producttype: this.producttype,
        //addincombo: this.addincombo,
        productgroup: this.productgroup,
        productcode: productcode,
        membergradeid: this.membergradeid,
        age: this.age,
        membergender: this.membergender,
        city: this.city,
        brandCode: this.queryBrandsCode
      })
        .then((response) => {
          if (response.data.result === '0000') {
            var rowlist = []
            var temporary = 0
            if (response.data.data != null) {
              response.data.data.forEach(function (arrRole, Index) {
                temporary += parseInt(arrRole.TemporaryPeople)
                switch (arrRole.Age) {
                  case 0:
                    rowlist.push({ '年紀': '20以下', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                    break
                  case 1:
                    rowlist.push({ '年紀': '20以下', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                    break
                  case 2:
                    rowlist.push({ '年紀': '20~29', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                    break
                  case 3:
                    rowlist.push({ '年紀': '30~39', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                    break
                  case 4:
                    rowlist.push({ '年紀': '40~49', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                    break
                  case 5:
                    rowlist.push({ '年紀': '50~59', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                    break
                  case 6:
                    rowlist.push({ '年紀': '60~69', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                    break
                  case 7:
                    rowlist.push({ '年紀': '70~79', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                    break
                  default:
                    rowlist.push({ '年紀': '80以上', '男': arrRole.Male, '女': arrRole.Female, '不公開': arrRole.Private })
                }
              })
            }
            this.chartData.rows = [
              { '年紀': '基本會員', '基本會員': temporary },
              { '年紀': '20以下', '男': 0, '女': 0, '不公開': 0 },
              { '年紀': '20~29', '男': 0, '女': 0, '不公開': 0 },
              { '年紀': '30~39', '男': 0, '女': 0, '不公開': 0 },
              { '年紀': '40~49', '男': 0, '女': 0, '不公開': 0 },
              { '年紀': '50~59', '男': 0, '女': 0, '不公開': 0 },
              { '年紀': '60~69', '男': 0, '女': 0, '不公開': 0 },
              { '年紀': '70~79', '男': 0, '女': 0, '不公開': 0 },
              { '年紀': '80以上', '男': 0, '女': 0, '不公開': 0 }
            ]
            if (rowlist.length > 0) {
              this.chartData.rows.forEach(function (arrRole, Index) {
                rowlist.forEach(function (arrRole1, Index1) {
                  if (arrRole['年紀'] === arrRole1['年紀']) {
                    arrRole['男'] = parseInt(arrRole['男']) + parseInt(arrRole1['男'])
                    arrRole['女'] = parseInt(arrRole['女']) + parseInt(arrRole1['女'])
                    arrRole['不公開'] = parseInt(arrRole['不公開']) + parseInt(arrRole1['不公開'])
                  }
                })
              })
            }
            var maxy = 10
            this.chartData.rows.forEach(function (arrRole, Index) {
              if (maxy < parseInt(arrRole['男'])) {
                maxy = parseInt(arrRole['男']) + 5
              }
              if (maxy < parseInt(arrRole['女'])) {
                maxy = parseInt(arrRole['女']) + 5
              }
            })
            this.chartSettings.max = [maxy]
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log(error)
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    getpost () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getallstores/v1', {
        brandCode: this.queryBrandsCode,
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.citylist = response.data.data
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    getProductAll () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 2,
        hasDelete: false,
        hasExtra: true,
        hasCombo: false,
        brandCode: this.queryBrandsCode
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.productgrouplist = response.data.data
            this.productlist = this.productgrouplist
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    productgroupchage () {
      var plist = []
      this.productcode = ''
      var pg = this.productgroup
      if (this.productgroup === '') {
        plist = this.productgrouplist
      } else {
        this.productgrouplist.forEach(function (arrRole, Index) {
          if (arrRole.Attribute === pg) {
            plist.push(arrRole)
          }
        })
      }
      this.productlist = plist
    },
    membergradechange () {
      if (this.membergradeid === 10) {
        this.membergender = ''
        this.age = 0
      }
    },
    // 取得套餐選單
    getAllCombos () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/getcombolist/v1', {
        brandCode: this.queryBrandsCode
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.combos = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    // 切換單點套餐
    producttypechange () {
      this.productgroup = ''
      this.productcode = ''
      this.combosid = ''
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/apporder/List.vue